<script>
  import Left from "common/icons/Left.svelte";
  import Right from "common/icons/Right.svelte";

  import Slide from "./carousel/Slide.svelte";
  import NavigationButton from "./carousel/NavigationButton.svelte";

  export let slides = [];
  export let width = 274;
  export let url;
  $: height = width * 0.666;
  $: actionTop = height / 2;
  let gap = 36;
  let clientWidth = 0;
  let offsetWidth = 0;
  let index = 0;

  $: columns = Math.max(Math.floor((clientWidth + 2) / (width + gap)), 1);
  $: groupWidth = columns * width + (columns - 1) * gap;
  $: groupTranslate = -index * (width + gap);
  $: maxIndex = Math.max(slides.length - columns, 0);
  $: if (index > maxIndex) {
    index = maxIndex;
  }
  function handleSlidefocus(slideIndex) {
    index = slideIndex;
  }
</script>

<style>
  .carousel {
    display: flex;
    justify-content: start;
  }

  .group-wrapper {
    position: relative;
  }

  .group {
    overflow: hidden;
    transition: ease-out 250ms width;
  }

  .slides {
    margin: 0;
    padding: 0;
    display: flex;
    transition: ease-out 250ms transform;
  }
</style>

<div
  class="carousel"
  bind:offsetWidth
  bind:clientWidth
  style="--slides-gap:{gap}px; --slides-action-top:{actionTop}px;">
  <div class="group-wrapper">

    <NavigationButton
      visible={index > 0}
      align="left"
      on:click={() => (index = index - 1)}>
      <Left fill="#fff" width="100%" height="auto" />
    </NavigationButton>

    <div class="group" style="width:{groupWidth}px; ">
      <div class="slides" style="transform:translateX({groupTranslate}px);">
        {#each slides as item, i (item.id)}
          <Slide
            {...item}
            {width}
            {height}
            pathBack={url}
            on:focus={(e) => handleSlidefocus(i)} />
        {/each}
      </div>
    </div>

    <NavigationButton
      visible={index < maxIndex}
      align="right"
      on:click={() => (index = index + 1)}>
      <Right fill="#fff" width="100%" height="auto" />
    </NavigationButton>

  </div>
</div>
